const DANGEROUS_PROTOCOL = /^(javascript|data|vbscript):/i;

/**
 * Réduit le risque XSS sur les snippets tracking admin :
 * - supprime les handlers inline (on*)
 * - bloque les URLs dangereuses dans href/src
 * - supprime les balises <script> sans attribut src externe
 */
export function sanitizeTrackingHtml(html: string): string {
  if (!html) return "";

  const template = document.createElement("template");
  template.innerHTML = html;

  const walk = (node: Element) => {
    Array.from(node.attributes).forEach((attr) => {
      const name = attr.name.toLowerCase();
      const value = attr.value.trim();

      if (name.startsWith("on")) {
        node.removeAttribute(attr.name);
        return;
      }

      if ((name === "href" || name === "src") && DANGEROUS_PROTOCOL.test(value)) {
        node.removeAttribute(attr.name);
      }
    });

    if (node.tagName === "SCRIPT") {
      const src = node.getAttribute("src");
      if (!src || DANGEROUS_PROTOCOL.test(src)) {
        node.remove();
        return;
      }
    }

    Array.from(node.children).forEach((child) => walk(child as Element));
  };

  Array.from(template.content.children).forEach((child) => walk(child as Element));

  return template.innerHTML;
}
